"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ProjectListPanel_1 = __importDefault(require("./ProjectListPanel"));
const EditorPanel_1 = __importDefault(require("./EditorPanel"));
const ActionPanel_1 = __importDefault(require("./ActionPanel"));
const KeyboardShortcutsHelp_1 = __importDefault(require("./KeyboardShortcutsHelp"));
const MainLayout = () => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex h-full bg-gray-50", children: [(0, jsx_runtime_1.jsx)("div", { className: "w-80 border-r border-gray-200 bg-white", children: (0, jsx_runtime_1.jsx)(ProjectListPanel_1.default, {}) }), (0, jsx_runtime_1.jsx)("div", { className: "flex-1 flex flex-col", children: (0, jsx_runtime_1.jsx)(EditorPanel_1.default, {}) }), (0, jsx_runtime_1.jsx)("div", { className: "w-96 border-l border-gray-200 bg-white", children: (0, jsx_runtime_1.jsx)(ActionPanel_1.default, {}) }), (0, jsx_runtime_1.jsx)(KeyboardShortcutsHelp_1.default, {})] }));
};
exports.default = MainLayout;
